import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { PAY_FILE_STATUS_TO_LABEL, PAY_FILE_TYPE_TO_LABEL } from "../../constants"
import type { PayFileSearchParams } from "../../types/searchParams"
import { formatPayFileDateRangeChipLabel } from "../../utils"

import { FilterChip } from "@/components/common/Filters"

interface PayFileFilterChipsProps {
  searchParams: PayFileSearchParams
  onRemove: (keyOrKeys: keyof PayFileSearchParams | (keyof PayFileSearchParams)[], value?: string | number) => void
}

export const PayFileFilterChips: FC<PayFileFilterChipsProps> = ({ searchParams, onRemove }) => {
  const { type, scheduledPayDateFrom, scheduledPayDateTo } = searchParams
  const statuses = searchParams.statuses ?? []

  const hasActiveFilters = statuses.length > 0 || Boolean(type || scheduledPayDateFrom || scheduledPayDateTo)

  if (!hasActiveFilters) return null

  return (
    <Box data-testid='pay-file.filter-chips' className='flex flex-wrap items-center gap-4'>
      <Typography variant='body1'>Filters:</Typography>

      {statuses.map((status) => (
        <FilterChip
          key={status}
          testId={`pay-file.filter-chips.status-${status.toLowerCase()}`}
          label={`Status: ${PAY_FILE_STATUS_TO_LABEL[status]}`}
          onDelete={() => onRemove("statuses", status)}
        />
      ))}

      {type && (
        <FilterChip
          testId='pay-file.filter-chips.type'
          label={`Type: ${PAY_FILE_TYPE_TO_LABEL[type]}`}
          onDelete={() => onRemove("type")}
        />
      )}

      {(scheduledPayDateFrom || scheduledPayDateTo) && (
        <FilterChip
          testId='pay-file.filter-chips.scheduled-pay-date-range'
          label={formatPayFileDateRangeChipLabel(scheduledPayDateFrom, scheduledPayDateTo)}
          onDelete={() => onRemove(["scheduledPayDateFrom", "scheduledPayDateTo"])}
        />
      )}
    </Box>
  )
}
